import { context, isValidSpanId, isValidTraceId, trace, TraceFlags } from '@opentelemetry/api';
import { traceContextService } from '../services/TraceContextService';

/**
 * Returns the appropriate OpenTelemetry parent context for a WS broadcast event.
 * If the provided OT (trace/span) identifiers are valid, constructs a remote span context.
 * Otherwise, falls back to the current active context from TraceContextService.
 *
 * @param {Object} ot - The object containing OpenTelemetry trace/span IDs from WS broadcast.
 * @param {string} [ot.trace] - The traceId (should be a valid 32-char hex string).
 * @param {string} [ot.span] - The spanId (should be a valid 16-char hex string).
 * @returns {import('@opentelemetry/api').Context} The parent context for the broadcast span.
 *
 * @example
 * const ctx = getWsBroadcastParentContext({ trace: 'abc...32', span: 'def...16' });
 */
export const getWsBroadcastParentContext = (ot) => {
    if (ot?.trace && isValidTraceId(ot?.trace) && isValidSpanId(ot?.span)) {
        return trace.setSpanContext(context.active(), {
            traceId: ot?.trace,
            spanId: ot?.span,
            traceFlags: TraceFlags.SAMPLED,
            isRemote: true,
        });
    }

    return traceContextService.getActiveParentContext();
};
